export default "/institutions/ally.svg";